import { DefaultValues } from 'react-hook-form';
import { PersonalPropertyItemFormValues } from '../types';
import { PersonalPropertyItem } from '../../../../generated/graphql';
import { monetaryAmountDataPointFormDefaultValue } from '../../Form';
import { getOwnershipInterestsFromOwnership } from '../../../../Owner';

export function getPersonalPropertyItemFormDefaultValues(
  personalPropertyItem: PersonalPropertyItem | null | undefined,
  defaultValues?: Partial<PersonalPropertyItemFormValues>
): DefaultValues<PersonalPropertyItemFormValues> {
  if (!personalPropertyItem) return { ...defaultValues };

  const ownershipInterest = getOwnershipInterestsFromOwnership(personalPropertyItem?.ownership);
  const owner = ownershipInterest?.owner;
  const ownerPercentage = ownershipInterest?.percentage;

  return {
    nickname: personalPropertyItem.name,
    notes: personalPropertyItem.notes || '',
    estimatedValue: monetaryAmountDataPointFormDefaultValue(personalPropertyItem.value.latestDataPoint),
    ownerData: { ownerID: owner?.id, ownerType: owner?.ownerType },
    ownershipAllocation: ownerPercentage == null ? null : ownerPercentage * 100,
    ...defaultValues,
  };
}
